import { render, staticRenderFns } from "./costConfig.vue?vue&type=template&id=140ad7e6&scoped=true&"
import script from "./costConfig.vue?vue&type=script&lang=js&"
export * from "./costConfig.vue?vue&type=script&lang=js&"
import style0 from "./costConfig.vue?vue&type=style&index=0&id=140ad7e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140ad7e6",
  null
  
)

export default component.exports